import React from "react";

const Laboratory = ({ className = "madie-icon", ...props }) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path d="M1.90638 16H12.0936C12.6099 16 13.0518 15.8177 13.4191 15.4531C13.7865 15.0885 13.9801 14.625 14 14.0625V14C14 13.5 13.8709 13.0312 13.6128 12.5938L8.90638 6V1.34375H9.53192C9.69078 1.34375 9.83972 1.27083 9.97872 1.125C10.1177 0.979167 10.1872 0.822917 10.1872 0.65625C10.1872 0.489583 10.1177 0.338542 9.97872 0.203125C9.83972 0.0677083 9.69078 0 9.53192 0H4.46809C4.30922 0 4.16028 0.0677083 4.02128 0.203125C3.88227 0.338542 3.81277 0.489583 3.81277 0.65625C3.81277 0.822917 3.88227 0.979167 4.02128 1.125C4.16028 1.27083 4.30922 1.34375 4.46809 1.34375H5.09362V5.9375L0.446809 12.5312C0.188652 12.9688 0.0595745 13.4167 0.0595745 13.875L0 14C0.0198582 14.5625 0.21844 15.0365 0.595745 15.4219C0.97305 15.8073 1.40993 16 1.90638 16ZM5.09362 8.1875L5.42128 7.8125C5.89787 7.10417 6.2156 6.30208 6.37447 5.40625V1.34375H7.62553V5.34375C7.80426 6.32292 8.12199 7.11458 8.57872 7.71875L8.90638 8.125L10.1872 9.9375H3.81277L5.09362 8.1875ZM1.45957 13.3438L2.92188 11.3438H3.18723H11.1404L12.5404 13.3438C12.5801 13.3854 12.6397 13.5833 12.7191 13.9375C12.7191 14.125 12.6546 14.2917 12.5255 14.4375C12.3965 14.5833 12.2525 14.6562 12.0936 14.6562H1.90638C1.74752 14.6562 1.60355 14.5833 1.47447 14.4375C1.34539 14.2917 1.28085 14.125 1.28085 13.9375C1.28085 13.6667 1.34043 13.4688 1.45957 13.3438Z" />
    </svg>
  );
};

export default Laboratory;
